import React from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';

const AmountChip = ({
   amount,
   selected,
   width,
   margin,
   onSelectAmount,
   children,
   isError,
   isShowInput,
}) => {
   const genearteStyle = () => {
      let style = {
         margin,
         width,
      }
      return style
   }
   return (
      <div
         role='presentation'
         onClick={ onSelectAmount ? () => onSelectAmount() : null }
         style={ genearteStyle() }
         className={ cx({
            'flex items-center justify-center rounded-lg cursor-pointer select-none border overflow-hidden': true,
            'skin-primary-border ': selected && !isError,
            'border-divider dark:border-divider-dark': !selected && !isError,
            ' dark:border-error-dark ': isError,
            'py-[10px] px-3': !isShowInput,
         }) }
      >
         {
            children && children
         }
         {
            amount && !children && (
               <span
                  className={ cx({
                     'leading-[18px] text-base whitespace-nowrap text-major dark:text-major-dark': true,
                  }) }
               ><span className='font-medium'>{amount}</span> USD </span>
            )
         }
      </div>
   );
};

AmountChip.propTypes = {
   amount: PropTypes.number,
   selected: PropTypes.bool,
   width: PropTypes.string,
   margin: PropTypes.string,
   onSelectAmount: PropTypes.func,
   children: PropTypes.any,
   isError: PropTypes.bool,
   isShowInput: PropTypes.bool,
};
AmountChip.defaultProps = {
   amount: 10,
   width: `calc(50% - 16px)`,
   type: 'tip',
   margin: '8px',
   onSelectAmount: () => {},
}
export default React.memo(AmountChip);
